import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import axios from 'axios'
import { DropDownList } from '@progress/kendo-react-dropdowns';
import Slider from "react-slick";
import './EndUserArchive.scss';
import { ROOT_API_URL } from "../../../../../api-config";
import { auth } from '../../../../../services';
import { history } from '../../../../../helpers/history';

import EventsFilter from '../Events/EventFilters';

class EndUserArchive extends Component {
    constructor(props) {
        super(props);

        this.state = {
            listOfArchives: [],
            filteredArchives: [],
            selectedYear: { description: 'All' },
            Years:[]
        }
    }

    componentDidMount() {
        this.getArchives();
    }

    getArchives(){
        axios.get(`${ROOT_API_URL}/Archive/GetArchives`, { headers: auth.authHeader() })
            .then((response) =>{
                    this.setState({
                        listOfArchives: response.data
                    })
                    var count = 0;
                    this.state.listOfArchives.forEach((element, key) => {
                        if(!this.state.Years.some(item => item.description === element.year)){
                             this.setState({
                                Years: [...this.state.Years,{id: count, description: element.year}]
                            });
                        }
                        count++;
                    });

                    this.setState({
                        Years: [...this.state.Years.sort((a, b) => a.description < b.description)]
                      });
                })
            .catch((response) => {
                console.log(response);
                history.push('/oops')
            });
    }

    handleYearChange = (event) => {

        this.setState({
            selectedYear: event.target.value,
            filteredArchives: this.state.listOfArchives.filter((item) => {
                if(item.year === event.target.value.description){
                    return item;
                }
            })
        })
    }

    renderArchiveList = () => {
        if(this.state.filteredArchives.length > 0) {
            return this.state.filteredArchives.map((archive) => {
                return(
                    <div className="archiveCard row" key={archive.archiveId}>
                      <div className="col-lg-3  d-flex flex-column align-items-center justify-content-center p-0">
                            <div className="header">
                                {
                                    archive.image ?
                                    <img src={archive.image} className="productImage" /> :
                                    <img src="/images/TSCRABackgroundLOGO.png" className="defaultImgHeight" alt="..." />
                                }
                            </div>
                      </div>
                      <div className="col-lg-4  d-flex flex-column justify-content-center pt-3 pt-lg-0 px-lg-4">

                            <h2>{archive.title}</h2>
                            <h4 className="productTitle">{archive.monthDescription} {archive.year} </h4>
                                <div className="layout">
                                <p className="descriptionText" >{archive.features}</p>
                                </div>
                            </div>

                      <div className="col-lg-3 d-flex flex-column justify-content-center  align-items-center pt-3 pt-lg-0">
                            <a href={archive.pdfUrl}><button className="pdfDownloadBtn">PDF Download</button></a>
                        </div>
                    </div>
                )}
            )
        } else {
            return this.state.listOfArchives.map((archive) => {
                return (
                    <div className="archiveCard row" key={archive.archiveId}>
                      <div className="col-lg-4 d-flex flex-column justify-content-start align-items-center p-0">
                            <div className="header test">
                                {
                                    archive.image ?
                                    <img src={archive.image} className="productImage" /> :
                                    <img src="/images/TSCRABackgroundLOGO.png" className="defaultImgHeight" alt="..." />
                                }
                            </div>
                      </div>
                      <div className="col-lg-5 d-flex flex-column  justify-content-center py-0 px-3">
                            <h2 className="dateAdjust">{archive.title}</h2>
                            <h4 className="productTitle">{archive.monthDescription} {archive.year} </h4>
                                <div className="layout">
                                <p className="descriptionText" >{archive.features}</p>
                                </div>
                          </div>

                      <div className="col-lg-3 d-flex flex-column align-items-center justify-content-center p-0" >
                            <a href={archive.pdfUrl}><button className="pdfDownloadBtn">PDF Download</button></a>
                        </div>
                    </div>
                )}
            )
        }
    }

    render() {
            return (
                <div className="eventsPage">
                    <div className="container">
                        <div className="archiveTitle">Magazines</div>
                        <div className="row adjustRowItems">
                                <div className="col-md-6 col-lg-3">
                                    <p className="filterTitle">Year: </p>
                                    <div className="dropdownCtr">
                                        <DropDownList
                                            data={[{ description: "All" }, ...this.state.Years]}
                                            textField="description"
                                            dataItemKey="id"
                                            value={this.state.selectedYear}
                                            defaultItem={{ description: 'All' }}
                                            onChange={this.handleYearChange}
                                        />
                                    </div>

                                </div>
                                <div className="col-md-6 col-lg-3">
                                    <button className="resetFilterBtn" onClick={() =>
                                    this.setState({
                                        filteredArchives: [],
                                        selectedYear:{ description: 'All' }
                                    })}>Reset Filters</button>
                                </div>
                            </div>
                        <div>
                            {this.renderArchiveList()}
                        </div>
                    </div>
                </div>
        );
    }
}

function mapStateToProps(state) {
   return {
       authentication: state.authentication,
       common: state.common
   }
}

export default connect(null, {})(EndUserArchive);
